module.exports = __webpack_public_path__ + "media/companies/Greenhill-a1b3b655.png";